import { render, staticRenderFns } from "./CartProducts-3.vue?vue&type=template&id=49588f56&"
import script from "./CartProducts-3.vue?vue&type=script&lang=js&"
export * from "./CartProducts-3.vue?vue&type=script&lang=js&"
import style0 from "./CartProducts-3.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports